import React from 'react';

interface FirebaseContextType {
    collectData: () => void;
    logEvent: (event?: any) => void;
    recordError: (error?: unknown) => void;
    crash: () => void;
    crashlyticsLog: (log?: unknown) => void;
}

const FirebaseContext = React.createContext<FirebaseContextType | undefined>(undefined);

export const mockContext: FirebaseContextType = {
    collectData: () => {},
    logEvent: () => {},
    recordError: () => {},
    crash: () => {},
    crashlyticsLog: () => {},
};

export default FirebaseContext;
